import React from 'react';
import { useFormik } from 'formik';
import { Form } from '@themesberg/react-bootstrap';
import { END_POINT_PO_SALES } from '../const';
import usePoPaymentTerms from '../hooks/usePoPaymentTerms';
import PoSalesFormFields, { poSalesFormSchema, poSalesPayload } from '../components/PoSalesFormFields';
import useRecordEditor from '../hooks/useRecordEditor';
import RecordEditFeedback from '../components/RecordEditFeedback';
import RecordEditActions from '../components/RecordEditActions';
import { buildQuoteProducts } from '../utils/quoteProducts';

export default function PoSaleEditForm({ poSaleId, onSuccess, onCancel, onSubmittingChange }) {
  const terms = usePoPaymentTerms();
  const editor = useRecordEditor({
    recordId: poSaleId, endpoint: END_POINT_PO_SALES, label: 'PO Sales',
    onSuccess, onSubmittingChange,
  });
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      products: buildQuoteProducts({ products: editor.record?.products }),
      po_number: editor.record?.po_number ?? '',
      po_release_date: String(editor.record?.po_release_date ?? '').slice(0, 10),
      po_received_date: String(editor.record?.po_received_date ?? '').slice(0, 10),
      delivery_due_date: String(editor.record?.delivery_due_date ?? '').slice(0, 10),
      po_to_principal_vendor: editor.record?.po_to_principal_vendor ?? 'No',
      payment_term: editor.record?.payment_term ?? '',
      status: editor.record?.status ?? 'Pending',
      remarks: editor.record?.remarks ?? '',
    },
    validationSchema: poSalesFormSchema(terms.data, editor.record?.payment_term),
    onSubmit: (values, helpers) => {
      if (terms.loading || terms.error) { helpers.setSubmitting(false); return; }
      return editor.submit(poSalesPayload(values), helpers);
    },
  });

  if (editor.loading || editor.loadError || !editor.record) {
    return <RecordEditFeedback loading={editor.loading} error={editor.loadError}
      label="PO Sales" onRetry={editor.retry} onCancel={onCancel} />;
  }

  const nested = editor.record.quote || {};
  const quote = {
    ...nested,
    system_quote_no: editor.record.system_quote_no || nested.system_quote_no,
    offer_no: editor.record.offer_no || nested.offer_no,
    offer_date: nested.offer_date || editor.record.offer_date,
    expected_date: nested.expected_date || editor.record.expected_date,
  };

  return (
    <Form noValidate onSubmit={formik.handleSubmit} aria-busy={formik.isSubmitting}>
      <PoSalesFormFields formik={formik} quote={quote} terms={terms} poNumberReadOnly
        actions={<RecordEditActions formik={formik} backTo="/po-sales" onCancel={onCancel}
          saveDisabled={terms.loading || Boolean(terms.error)} />} />
    </Form>
  );
}
